import React, { FC } from 'react';
// eslint-disable-next-line import/no-cycle
import { SystemManager } from '../../../utils/SystemManager';

const SinTarjetaOro: FC = () => {
  return <div>{SystemManager.getSystem('tarjeta-oro')}</div>;
};

export default SinTarjetaOro;
